// Copyright 2018 Ping Identity
//
// Licensed under the MIT License (the "License"); you may not use this file
// except in compliance with the License.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { Component, OnInit, AfterViewInit } from '@angular/core';
//import jwt_decode from "jwt-decode";
import { Router } from '@angular/router';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/services/app.service';
import { JWTTokenService } from 'src/app/services/JWTTokenService';
import { LoggingService } from 'src/app/services/logging.service';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss']
})
export class CallbackComponent implements OnInit {

  constructor(private appService: AppService, private jwtTokenService: JWTTokenService, public authorizationService: AuthorizationService,
     public router: Router, private spinnerService: NgxSpinnerService, private loggingService: LoggingService) { }

  ngOnInit(): void { 
    if (new URLSearchParams(window.location.search).has('code')) {
      this.spinnerService.show();
      this.authorizationService.completeAuthorizationRequest().then((tokenResponse) => {
        if (tokenResponse && tokenResponse.accessToken) {
          this.jwtTokenService.setToken(tokenResponse.accessToken);
          let userInfo = this.jwtTokenService.getUser();
          this.loggingService.setAuthenticatedUserId(userInfo.email);
          this.spinnerService.hide();
          this.router.navigate(['home']);
        }
        else {
          alert('Unable to retrive access token');
          this.spinnerService.hide();
          this.router.navigate(['authenticate']);
        }

      }).catch((error) => {
        alert('Authenticatoin Failed!');
        this.spinnerService.hide();
        this.router.navigate(['authenticate']);
      });
      //   }
      // } 
      // else
      //  {
      //   this.spinnerService.hide();
      //   this.router.navigate(['home']);
      // }
    } else {
    }
  }

}
